import LocalStorage from 'quasar/src/plugins/LocalStorage.js';
import getDefaultState from './state';

export function flush(state) {
  Object.assign(state, getDefaultState());
}

export function updateUser(state, payload) {
  state.uuid = payload.uuid;
  state.accessToken = payload.accessToken;
  state.pushToken = payload.androidPushToken;
  state.externalId = payload.externalId;
  state.role = payload.roleId;
  state.phone = payload.phone;
  state.name = payload.name;
  state.email = payload.email;
  state.address = payload.address;
  state.extra = payload.extra;
  state.creditAmount = payload.creditAmount;
  state.postalCode = payload.postalCode;
  // state.paymentMethods = payload.paymentMethods;
  state.addresses = payload.addresses;
  // Don't override currently set state. Only update if supplied. Only set when authenticating.
  state.isInternal = payload.isInternal ? payload.isInternal : state.isInternal;
}

export function updateAllUsers(state, { users }) {
  state.all = users;
}

export function updateAllOrders(state, payload) {
  state.orders = payload;
}

export function updateUserExtra(state, payload) {
  state.extra = payload;
}

export function updateLoggedIn(state, payload) {
  state.isLoggedIn = payload;
}

export function storeUserInLocalStorage(state) {
  LocalStorage.set('user', state);
}

export function removeUserFromLocalStorage() {
  LocalStorage.remove('user');
}

export function updateUserSettings(state, payload) {
  state.name = payload.name;
  state.extra = payload.extra;
  state.address = payload.address;
  state.postalCode = payload.postalCode;
}

export function updateUserAddress(state, payload) {
  state.address = payload;
}

export function updateUserPostalCode(state, payload) {
  state.postalCode = payload;
}

export function setUserPaymentMethod(state, payload) {
  state.paymentMethods = payload;
}

export function setUserItems(state, payload) {
  state.items = payload;
}

export function updateUserPushToken(state, { token }) {
  state.pushToken = token;
}
